import React from "react";
import './form-field-line-layout.scss';

interface IFormFieldLineLayoutProps {
    children: React.ReactNode;
}

const FormFieldLineLayout = ({children} : IFormFieldLineLayoutProps) => (
    <div className="form-field-line-layout">{children}</div>
);

export default FormFieldLineLayout;